module.exports = __webpack_public_path__ + "static/a-titan-raises-the-bar-menu-thumbnails-400x400-02c1620a768b9f4c4a704d38e26dbc2f.jpg";